"use strict";

(function (global) {

  var selectors = {
    details: '.Reference_Detail',
    links: 'a',
    buttons: '.CardForm_Button, .wizard-form__button',
    tabs: '.sidebar_item, .tab_item',
    searches: '.explorer-search-panel__item',
    toolBarButtons: '.toolbar_button',
    toolBarGroups: '.toolbar_group'
  };

  /**
  * Предоставляет механизм инициализации дочерних пространств имен для оберток
  * элементов формы.
  *
  * @mixin WebAccess.mixins.formMixin
  * @since 5.2.0.1600
  * @property {WebAccess.components.wrappers.form.Form} form - форма
  * @property {WebAccess.components.wrappers.details.Detail} details - детальные разделы
  * @property {WebAccess.components.wrappers.details.sideBar.SideBar} sideBar - форма
  * @property {BaseObject} toolBar - панель инструментов
  * @property {window} toolBar - панель инструментов //TODO
  * @property {Object} states - deferred объекты инициализации оберток
  */

  var formMixin = {
    Init: null,
    form: null,
    details: null,
    sideBar: null,
    toolBar: null,
    window: null,
    objectList: null,
    states: null,
    //---------------------------------------------------------------------//

    /**
     * Установка начальных значений deferred объектов;
     * @method _preInit
     * @private
     * @return {WebAccess.mixins.formMixin} расширяемый класс
     */
    _preInit: function () {
      var me = this;
      me.states = {
        objectList: $.Deferred(),
        details: $.Deferred(),
        toolBarButtons: $.Deferred(),
        toolBarGroups: $.Deferred(),
        tabs: $.Deferred(),
        tables: $.Deferred(),
        links: $.Deferred(),
        buttons: $.Deferred(),
        form: $.Deferred()
      };

      // Блок подписки на события должен находиться в mixin, чтобы одинаково
      // работать как для диалогов, так и для окна веб-доступа. Если перенести этот
      // блок в current.js, он будет работать только для WA.CR
      $('html').one(PAGE_EVENTS.TOOLBAR_BUTTONS_INIT_DONE, () => {
        this.states.toolBarButtons.resolve();
      }).one(PAGE_EVENTS.TOOLBAR_GROUPS_INIT_DONE, () => {
        this.states.toolBarGroups.resolve();
      });

      me.Init = $.Deferred();
      return me;
    },
    //---------------------------------------------------------------------//

    /**
     * Заполенение и инициализация дочерних пространств имен
     * @method _postInit
     * @private
     * @return {WebAccess.mixins.formMixin} расширяемый класс
     */
    _postInit: function () {
      var me = this;
      var WR = global.CMP.wrappers;

      me._containerInit.done(function () {
        me._jContainer = $(me.containerSelector);

        me.details = me._getSubItems(selectors.details, WR.details.Detail);
        me.states.details.resolve();

        me.form = new WR.form.Form(me._getFormData(), me.serviceURL, me);
        me.form.controls = new BaseObject();
        me.form.Init.then(function () {
          me.states.form.resolve();
        });

        if ($.isFunction(me._initObjectList)) {
          me._initObjectList();
        } else {
          console.warn('It is necessary to implement _initObjectList method in ' + me.className + '.');
        }
        me.states.objectList.resolve();

        me.form.controls.links = new global.Collection(me._getSubItems(selectors.links, WR.form.Link));
        me.states.links.resolve();
        me.form.controls.buttons = new global.Collection(me._getSubItems(selectors.buttons, WR.form.Button));
        me.states.buttons.resolve();

        if (!WA.isMobile()) {
          if (me.className === 'Current' && WA.getLocation() === 'explorer') { //спецобработка
            me.sideBar = new WR.sideBar._ExplorerSideBar(me.containerSelector + ' ' + me._sideBarContainerSelector, me);
            me.sideBar.tabs = new WR.sideBar._ExplorerTabs(me._getSubItems(selectors.searches, WR.sideBar._ExplorerTab), me.containerSelector + ' ' + me._sideBarContainerSelector, me);
          } else {
            me.sideBar = new WR.sideBar.SideBar(me.containerSelector + ' ' + me._sideBarContainerSelector, me);
            me.sideBar.tabs = new WR.sideBar.Tabs(me._getSubItems(selectors.tabs, WR.sideBar.Tab), me.containerSelector + ' ' + me._sideBarContainerSelector, me);
          }
        }

        me.states.tabs.resolve();
        
        // В диалогах отсутствует тулбар, поэтому сгенерируем события его инициализации
        if (me.className === 'FormDialog') {
          $('html').trigger(PAGE_EVENTS.TOOLBAR_BUTTONS_INIT_DONE);
          $('html').trigger(PAGE_EVENTS.TOOLBAR_GROUPS_INIT_DONE);
        } else if (!window.g_hasReactToolbar) {
          // Получить список кнопок
          var buttons = new WR.toolBar.Buttons(me._getSubItems(selectors.toolBarButtons, WR.toolBar.ToolBarButton));
          me.toolBar = new BaseObject();
          if (!WA.isMobile()) {
            me.toolBar = new WR.toolBar.ToolBar();
            me.toolBar.buttons = buttons;
            $('html').trigger(PAGE_EVENTS.TOOLBAR_BUTTONS_INIT_DONE);
            me.toolBar.groups = new WR.toolBar.Groups(me._getSubItems(selectors.toolBarGroups, WR.toolBar.ToolBarGroup));
          }

          $('html').trigger(PAGE_EVENTS.TOOLBAR_GROUPS_INIT_DONE);
        } else {
          // TODO переделать ресайз панели вкладок, чтобы она не зависела от тулбара.
          // Вызываем ресайз панели закладок, чтобы она подстроилась под размер окна при первом открытии.
          me.sideBar.resizeHorizontalTabs()
        }              
      });


      me._detailsGridInit.done(function () {
        var tableParams = {
          formData: me._getFormData(),
          grids: me._getGrids(),
          objectLink: me._getObjectLink(),
          objectView: me._getObjectView(),
          serviceURL: me.serviceURL,
          current: me
        };

        var tables = me._getSubItems(selectors.details, global.CMP.wrappers.form.Table, tableParams);
        var tablesInit = [];
        for (var key in tables) {
          var table = tables[key];
          tablesInit.push(table.Init);
        }
        $.when.apply(me, tablesInit).then(function () {
          me.form.controls.tables = tables;
          me.states.tables.resolve();
        });
      });

      var states = _(me.states).values();
      $.when.apply(me, states).always(function () {
        me.Init.resolve();
        if (!WA.isMobile()) {
          me._jContainer.find('input[type="text"], textarea').not('.Req_Disabled').first().focus().select(); //#106799
        }
      });

      return me;
    },
    //---------------------------------------------------------------------//

    /**
     * Заполнение дочернего пространства соответсвующими элементами
     *
     * @param {string} elementSelector селектор искомого элемента
     * @param {Class} ComponentClass класс обертки для элемента
     * @param {Object} [params = this] параметры передаваемые в конструктор элемента обертки
     * @private
     * @return {Array} список объектов-оберток
     */
    _getSubItems: function (elementSelector, ComponentClass, params = {current: this}) {
      const items = {};

      const jSearchTarget = this._jContainer.find(elementSelector);
      jSearchTarget.each((index, domElement) => {
        const elem = new ComponentClass(domElement, params);
        const item = items[elem.name] = items[elem.name] || Object.assign(elem, {
          _jSubElements: [],
        });
        item._jSubElements.push(domElement);
      });

      return items;
    },
    //---------------------------------------------------------------------//


    /**
     * Навешивает на все реквизиты строки таблицы логику работы ведущих/ведомых.
     * @method _bindLeaderDrivenLoginOnRequisites
     * @private
     * @param {WebAccess.components.wrappers.form.Table} table Таблица, на которую навешивается логика ведущих/ведомых.
     * @param {WebAccess.components.wrappers.form.TableRow} row Строка, на которую навешивается логика ведущих/ведомых.
     */
    _bindLeaderDrivenLoginOnRequisites: function (table, row) {
      var me = this;
      var reqs = row.requisites.toArray();
      for (var j = 0; j < reqs.length; j++) {
        var req = reqs[j];
        var currentColumnMetadata = table.getColumnMetadata(req.name);

        if (currentColumnMetadata) {
          var reqInfo = currentColumnMetadata.Requisite;
          if (reqInfo) {
            if (reqInfo.leaderRequisites && reqInfo.lookUpLeaderRequisites && reqInfo.drivenRequisites) {

              var leader = _($.parseJSON(reqInfo.leaderRequisites)).map(function (leadReq) {
                return { tableName: table.name, rowId: row.getRowId(), reqName: leadReq };
              });

              var lookup = $.parseJSON(reqInfo.lookUpLeaderRequisites);
              var driven = _($.parseJSON(reqInfo.drivenRequisites)).map(function (drivenReq) {
                return { tableName: table.name, rowId: row.getRowId(), reqName: drivenReq };
              });

              me._initLeaderDrivenLogic(req, leader, lookup, driven);
            }
          }
        }
      }
    },

    /**
     * Навешивает на все реквизиты таблицы логику работы ведущих/ведомых.
     * @method bindLeaderDrivenLogicToTable
     * @param {WebAccess.components.wrappers.form.Table} table Таблица, на которую навешивается логика ведущих/ведомых.
     */
    bindLeaderDrivenLogicToTable: function (table) {
      var me = this;
      // Для существующих строк.
      var rows = table.rows.toArray();
      for (var i = 0; i < rows.length; i++) {
        (function (_table, _row) {
          me._bindLeaderDrivenLoginOnRequisites(_table, _row);
        })(table, rows[i]);
      }
      // Для новых строк.
      (function (_table) {
        _table.bind('addRow', function (newRow) {          
          me._bindLeaderDrivenLoginOnRequisites(_table, newRow);
        });
      })(table);
    },

    /**
     * Навешивает на все реквизиты таблицы всех детальных разделов логику работы ведущих/ведомых.
     * @method bindLeaderDrivenLogic
     */
    bindLeaderDrivenLogic: function () {
      var me = this;

      $.when(me.states.tables).then(function () {
        for (var tableName in me.form.controls.tables) {
          var table = me.form.controls.tables[tableName];
          (function (_table) {
            me.bindLeaderDrivenLogicToTable(_table);
          })(table);
        };
      });

      return me;
    },

    /**
     * Инициализация логики ведущих/ведомых для реквизита.
     * @method _initLeaderDrivenLogic
     * @private
     * @param {WebAccess.components.wrappers.form.Table} req Реквизит, на которую навешивается логика ведущих/ведомых.
     * @param {array} leader Ведущие реквизиты.
     * @param {array} lookup lookup-реквизиты.
     * @param {array} driven Ведомые реквизиты.
     * @return {WA.formMixin} Текущий миксин.
     */
    _initLeaderDrivenLogic: function (req, leader, lookup, driven) {
      var me = this;

      if (!req || (leader.length === 0 && driven.length === 0)) return me;

      req.bind('editModeChange', function (editMode) {
        // Только в режиме редактирования можно означить фильтр по значениям ведущих.
        if (!editMode) return;

        _(req._getControls()).each(function (jInput) {
          var rs = jInput.data('ReferenceSelectInstance');
          if (rs && rs.extraParams) {
            var extraParams = rs.extraParams;
            // Устанавливаем условие фильтрации и необходимость загрузки lookup-реквизитов по ведущим реквизитам.
            $.extend(extraParams, {
              LeadSelID: function () {
                return me._getLookupValues(leader, lookup);
              }
            });
            rs.extraParams = extraParams;
          }
        });
      });

      req.bind('changeWithLeaderValues', function (jControl, ev, data, needClearDriven) {
        //data = { name: ..., value: ..., displayValue: ..., leaderRequisiteValues: ... }

        if (data && data.value !== null) {
          // Надо бы заполнить ведущиеи очистить ведомые.

          // Очищаем ведомые.
          if (needClearDriven) {
            me._clearRequisitesValue(driven);
          }
          // Заполняем ведущие.
          fillLeaderRequisites(data);

          // Заполняем ведомые, если в них одно значение (См. FillDrivenIfItResultHasOneRecord).
          //В билдере эта логика не срабатывает, поэтому и у нас не сделал.

        } else {
          // Очищаем ведомые.
          me._clearRequisitesValue(driven);
        }

        //Заполняет ведущие реквизиты
        function fillLeaderRequisites(data) {
          for (var i = 0; i < leader.length; i++) {
            var leadValues = data.leaderRequisiteValues[lookup[i]];
            if (leadValues) {
              var leadReq = me._getRequisiteByFullName(leader[i]);
              if (leadReq) {

                //Устанавливаем значение для ведущего реквизита
                leadReq.setValue(leadValues[0], leadValues[2], true);

                //Пытаемся установить значение ведущих реквизитов для текущего ведущего
                me._fillLeaderForDetailSectionRequisite(leadReq, leadValues[0]);
              }
            }
          }
        }


      });

      return me;
    },

    /**
     * Возвращает значения ведущих реквизитов в формате URL, т.е. name1=value1&name2=value2...
     * 
     * @param {Array<object>} leader Массив из {tableName: ..., rowId: ..., reqName: ...}
     * @param {Array<string>} lookup Массив имен ведущих реквизитов
     * @returns {} 
     */
    _getLookupValues: function (leader, lookup) {
      var me = this;
      var val = '';
      for (var i = 0; i < leader.length; i++) {
        var leadReq = me._getRequisiteByFullName(leader[i]);
        if (!leadReq) continue;
        var leadReqVal = leadReq.getValue();
        val += lookup[i] + '|' + leadReq.name + '=' + (leadReqVal ? leadReqVal : '') + '&';
      };
      return val;
    },

    /**
     * Возвращает объект реквизита по его полному имени
     * 
     * @param {object} fullName Моделька полного имени реквизита вида {tableName: ..., rowId: ..., reqName: ...}
     * @returns {object} Реквизит
     */
    _getRequisiteByFullName: function (fullName) {
      var me = this;
      if (_.isString(fullName)) {
        // Реквизит карточки.
        return me.form.requisites[fullName];
      } else {
        // Реквизит детального раздела.
        return me.form.controls.tables[fullName.tableName].getRowById(fullName.rowId).requisites[fullName.reqName];
      }
    },

    /**
     * Чистит значения реквизитов.
     * 
     * @param {Array<object>} reqFullNames массив моделек вида {tableName: ..., rowId: ..., reqName: ...}
     */
    _clearRequisitesValue: function (reqFullNames) {
      var me = this;
      for (var i = 0 ; i < reqFullNames.length; i++) {
        var drivenReq = me._getRequisiteByFullName(reqFullNames[i]);
        if (drivenReq) drivenReq.clear(true);
      }
    },

    /**
     * Заполняет ведущие реквизиты для текущего реквизита с заданным значением
     * 
     * @param {object} requisite Реквизит, для которого буду заполнены ведущие
     * @param {int} value Значение реквизита, для которого буду заполнены ведущие
     */
    _fillLeaderForDetailSectionRequisite: function (requisite, value) {
      var me = this;
      var row = requisite.getRow();
      var table = row.getTable();
      var currentColumnMetadata = table.getColumnMetadata(requisite.name);

      if (currentColumnMetadata) {
        var reqInfo = currentColumnMetadata.Requisite;
        if (reqInfo) {

          var settings = $.parseJSON(reqInfo.settings);
          var params = getReferenceSelectParams(reqInfo, settings, value);

          ReferenceSelectDataProvider.sendQuery(settings.url, params, function (count, res) {
            var data = res[0];
            if (data && data.leadingRequisitesValue !== "{}") {
              requisite.fire('changeWithLeaderValues', null, null, { name: data.encodedTitle, value: data.id, displayValue: data.title, leaderRequisiteValues: $.parseJSON(data.leadingRequisitesValue) }, false);
            }
          });
        }
      }

      /**
       * Возвращает параметры для запроса на выборку реквизита с конкретным ИД
       * 
       * @param {object} reqInfo Метаинформация реквизита
       * @param {object} settings Метаинформация реквизита
       * @param {number} recordId ИД записи, которое попадет в условие выборки
       * @returns {object} Параметры запроса
       */
      function getReferenceSelectParams(reqInfo, settings, recordId) {
        var leader = null;
        var lookup = null;
        if (reqInfo.leaderRequisites && reqInfo.lookUpLeaderRequisites) {

          leader = _($.parseJSON(reqInfo.leaderRequisites)).map(function (leadReq) {
            return { tableName: table.name, rowId: row.getRowId(), reqName: leadReq };
          });

          lookup = $.parseJSON(reqInfo.lookUpLeaderRequisites);
        }

        var refCode = requisite.getReferences()[0];
        var queryContext = settings.queryContext;
        // Множественный выбор ссылается на несколько ревизитов, поэтому меняем контекст.
        if (settings.referenceCodesAndReqNamesInDetailSection && settings.referenceCodesAndReqNamesInDetailSection[refCode]) {
          queryContext = JSON.parse(queryContext);
          queryContext.requisiteNumber = settings.referenceCodesAndReqNamesInDetailSection[refCode].number;
          queryContext = JSON.stringify(queryContext);
        }

        return $.extend({
          q: "",
          filter: "[ИД]=" + recordId,
          useadditional: settings.useadditional ? "1" : "0",
          disablespecialprocessing: "1",
          queryContext: queryContext,
          LeadSelID: me._getLookupValues(leader, lookup)
        }, {});
      }
    }
  };

  global.mixins.formMixin = formMixin;
})(window.WebAccess);
